const FIRST_MACHINE_ACTIVATION_PREFIX = 'route42:first-machine-activation:';

function key(customerId: string): string {
  return `${FIRST_MACHINE_ACTIVATION_PREFIX}${customerId}`;
}

export function markFirstMachineActivationSession(customerId: string): void {
  if (!customerId) return;
  try {
    sessionStorage.setItem(key(customerId), '1');
  } catch {
    // This marker only prevents the Product Tour from competing while the
    // organization's first machine is being created. Successful creation clears
    // it before the workspace handoff. It is never authorization or setup state.
  }
}

export function isFirstMachineActivationSession(customerId: string): boolean {
  if (!customerId) return false;
  try {
    return sessionStorage.getItem(key(customerId)) === '1';
  } catch {
    return false;
  }
}

export function clearFirstMachineActivationSession(customerId: string | null): void {
  if (!customerId) return;
  try {
    sessionStorage.removeItem(key(customerId));
  } catch {
    // Best-effort UX cleanup only.
  }
}
